export const decisionActions = {
  REFRESH_DECITIONS_TREE: 'REFRESH_DECITIONS_TREE',
  ADD_DECISION: 'ADD_DECISION',
  UPDATE_DECISIONS_TREE: 'UPDATE_DECISIONS_TREE'
}